module.exports = __webpack_public_path__ + "fonts/12bb98121b73413a611020b2b97482f1.svg";